import { FeatureFlagManifest } from './check-feature-flag';

export const featureFlags = {
	operationsLandFlow: {
		featureFlagName: 'alx_operations_land_flow',
		metadata: {
			description:
				'Operations Land Flow for explicit Incident management selection (ALX-1168). Default off; controlled rollout only.',
			expectedReleaseDate: 'TBD',
			expectedRuntime: 'TBD',
			context: { urls: ['/ondemand/signup/confirmation'] },
		},
	},
	wacUfoEventProvisioningLatency: {
		featureFlagName: 'wac-ufo-event-provisioning-latency',
		metadata: {
			description:
				'Measure product setup and end-to-end provisioning latency with dedicated UFO experiences (STARB-4965).',
			expectedReleaseDate: 'TBD',
			expectedRuntime: '4 weeks',
			context: {
				urls: ['/ondemand/signup/confirmation'],
			},
		},
	},
	gwp13694RovoDevEol: {
		featureFlagName: 'gwp-13694-rovo-dev-eol',
		metadata: {
			description: 'Feature gate for Rovo Dev end-of-life changes across WAC.',
			expectedReleaseDate: '10/02/2026',
			expectedRuntime: 'indefinite',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	team26EuRefresh: {
		featureFlagName: 'team_26_eu_refresh',
		metadata: {
			description:
				'Team 26 (Growth - TOFU - Spark) EU page refresh — gates all WAC pages launching during the conference.',
			expectedReleaseDate: 'TBD',
			expectedRuntime: '1 week',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	wacSwitcherNoFetchJoinableSites: {
		featureFlagName: 'wac-switcher-no-fetch-joinable-sites',
		metadata: {
			description:
				'SWITCH-1150: When ON, the WAC app switcher stops calling /joinable-sites and passes an empty joinable sites provider instead. WAC renders the switcher with product "WAC" and the shared switcher only renders joinable-site links for Jira and Confluence, so the response was never shown. When OFF, the existing fetch behaviour is unchanged.',
			expectedReleaseDate: '10/2/2026',
			expectedRuntime: 'Indefinite',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	team26EuKeynote: {
		featureFlagName: 'wac_team_26_eu_keynote',
		metadata: {
			description:
				'Team 26 EU gate releasing in sync with the keynote address for announcements that cannot launch ahead of the event.',
			expectedReleaseDate: 'TBD',
			expectedRuntime: 'Indefinite',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	teamTypeGridScrollbarBugfix: {
		featureFlagName: 'spice-2698-bugfix',
		metadata: {
			description:
				'Fixes spurious horizontal and vertical scrollbars on the team type card grid in Safari. When off, the previous behaviour is restored.',
			expectedReleaseDate: '09/08/2026',
			expectedRuntime: '4 weeks',
			context: {
				urls: ['/ondemand/signup/confirmation'],
			},
		},
	},
	jsmLandUseCaseOnboardingBugfix: {
		featureFlagName: 'jsmgrowth_519_jsm_land_use_case_onboarding_bugfix',
		metadata: {
			description:
				'Controls reliability and observability fixes for JSM land use-case onboarding project provisioning.',
			expectedReleaseDate: '11/03/2026',
			expectedRuntime: '12 weeks',
			context: {
				urls: ['/ondemand/signup/confirmation'],
			},
		},
	},
	jsmGrowth528ImproveProvisioningWac: {
		featureFlagName: 'jsmgrowth-528_improve_provisioning_wac',
		metadata: {
			description:
				'Controls propagation of explicit JSM intent from Service Collection pricing CTAs.',
			expectedReleaseDate: '10/19/2026',
			expectedRuntime: '',
			context: {
				urls: ['/collections/service/pricing'],
			},
		},
	},
	jiraOnboardingWizardRefactorInvites: {
		featureFlagName: 'spice-refactor-jira-onboarding-wizard-invites',
		metadata: {
			description:
				'Enable the in-house invite email input in the Jira onboarding wizard invite step, replacing the @atlassian/invite-people component. Old path remains as fallback when the gate is off.',
			expectedReleaseDate: '08/28/2026',
			expectedRuntime: 'Indefinite',
			context: {
				urls: ['/ondemand/signup/confirmation'],
			},
		},
	},
	salesWidgetBxpWebPlatform: {
		featureFlagName: 'sales_widget_bxp_web_platform',
		metadata: {
			description: 'Flag to enable sales widget on BXP web platform',
			expectedReleaseDate: '10/03/2026',
			expectedRuntime: 'Indefinite',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	salesWidgetBxpWebPlatformDeveloper: {
		featureFlagName: 'sales_widget_bxp_web_platform_dev',
		metadata: {
			description: 'Flag to enable sales widget on BXP web platform for developers',
			expectedReleaseDate: '10/03/2026',
			expectedRuntime: 'Indefinite',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	preloadAtlaskitStyles: {
		featureFlagName: 'token-style-wrapper-wac-web-gate',
		metadata: {
			description: 'Flag to enable optimized Atlas token head loading.',
			expectedReleaseDate: '08/30/2025',
			expectedRuntime: 'Can be cleaned up after monitored in PROD and ensure no issues',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	castleIoEvent: {
		featureFlagName: 'wac-castle-io-event',
		metadata: {
			description: 'Feature gate to control Castle.io custom event sending',
			expectedReleaseDate: '2026-06-30',
			expectedRuntime: '4 weeks',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	jsmPaidLpAuxiaIntegration: {
		featureFlagName: 'jsm-paid-lp-auxia-integration',
		metadata: {
			description: 'Feature gate to roll out Auxia integration for JSM Paid LP Anchor pages',
			expectedReleaseDate: '9/22/2025',
			expectedRuntime: '12 weeks',
			context: {
				urls: ['/software/jira/service-management'],
			},
		},
	},
	sxpFspFullWidth: {
		featureFlagName: 'sxp_fsp_full_width',
		metadata: {
			description: 'Feature gate to enable the full-width layout in FastShift Portal',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				urls: ['/fastshift/**'],
			},
		},
	},
	sxpFspMigrationPlans: {
		featureFlagName: 'sxp_fsp_migration_plans',
		metadata: {
			description: 'Feature gate to enable migration plans in FastShift Portal',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				urls: ['/fastshift/**'],
			},
		},
	},
	sxpFspToolsMenuCsProfiler: {
		featureFlagName: 'fsp_tools_menu_cs_profiler',
		metadata: {
			description: 'Feature gate to enable the CS Profiler tools menu item in FastShift Portal',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				urls: ['/fastshift/**'],
			},
		},
	},
	gwp1304AddIntercomToJpdProductTour: {
		featureFlagName: 'gwp-1304-add-intercom-to-jpd-product-tour',
		metadata: {
			description: 'Add Intercom to JPD Product Tour',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				urls: ['/software/jira/product-discovery'],
			},
		},
	},
	provisioningFunnelUfoImprovements: {
		featureFlagName: 'provisioning-funnel-ufo-improvements',
		metadata: {
			description:
				'Feature gate to enable provisioningFunnelUfoImprovements for UFO tracking in provisioning UI',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				urls: ['/ondemand/signup/confirmation'],
			},
		},
	},
	wacWebTrafficAAGate: {
		featureFlagName: 'wac-web-traffic-aa-gate',
		metadata: {
			description: 'WAC Web Traffic AA Gate',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	wacWebLoggedInTrafficAAGate: {
		featureFlagName: 'wac-web_a-a_gate_for_loggedin_users',
		metadata: {
			description: 'WAC Web LoggedIn Traffic AA Gate',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	gwp5158FocusProductAdd: {
		featureFlagName: 'gwp-5158-focus-product-add',
		metadata: {
			description: 'Adding Focus to global nav',
			expectedReleaseDate: 'April 9, 2025',
			expectedRuntime: 'Forever (gate to be used for Team launch, will be cleaned up)',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	gwp4947Team25HeroHomepageTakeover: {
		featureFlagName: 'gwp-4947-team-25-hero-homepage-takeover',
		metadata: {
			description: 'Team 25 hero takeover',
			expectedReleaseDate: 'February',
			expectedRuntime: 'Until April 8th',
			context: {
				urls: ['/', '/enterprise'],
			},
		},
	},
	gwp5046TurboBannerEnterprise: {
		featureFlagName: 'gwp-5046-turbo-banner-enterprise',
		metadata: {
			description: 'Turbo racing banner',
			expectedReleaseDate: 'February',
			expectedRuntime: 'Until April 8th',
			context: {
				urls: ['/enterprise'],
			},
		},
	},
	gwp5381AddIntercomWidgetToUniform: {
		featureFlagName: 'gwp-5381-add-intercom-widget-to-uniform',
		metadata: {
			description: 'Add Intercom widget to Uniform Page component',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				urls: ['/customers/*'],
			},
		},
	},
	wacProductsLoomURL: {
		featureFlagName: 'wac-products-loom-url',
		metadata: {
			description: 'Change loom URL',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	edgeLambdaCacheProductDiscovery: {
		featureFlagName: 'edge-lambda-cache-product-discovery',
		metadata: {
			description: 'Flag to enable edge lambda caching for product discovery page',
			expectedReleaseDate: '03/18/2025',
			expectedRuntime: 'Indefinite',
			context: {
				urls: [
					'/software/jira/product-discovery',
					'/',
					'/customers*',
					'/software/confluence/templates*',
					'/work-management*',
					'/itsm*',
					'/incident-management*',
					'/agile*',
				],
				// TODO: GWP-8863 Update regex handler - /software/confluence/templates/categories or /software/confluence/templates/search are not going through edge cache
			},
		},
	},
	edgeCacheSourcetreapp: {
		featureFlagName: 'edge-cache-sourcetreapp',
		metadata: {
			description: 'Flag to enable edge caching for all sourcetreeapp.com domain paths',
			expectedReleaseDate: '05/05/2026',
			expectedRuntime: 'Indefinite',
			context: {
				urls: [
					// eslint-disable-next-line local/warn-wildcard-usage-eslint
					'sourcetreeapp.com/**',
				],
			},
		},
	},
	wacWebUseEsModulesScripts: {
		featureFlagName: 'wac-web-use-esmodules-scripts',
		metadata: {
			description: 'Use Esmodules script',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	gwp5548Team25DuringEventBanner: {
		featureFlagName: 'gwp-5548-team-25-during-event-banner',
		metadata: {
			description: 'Team 25 During event banner',
			expectedReleaseDate: '4/9/2025',
			expectedRuntime: '1 day',
			context: {
				urls: ['/'],
			},
		},
	},
	gwp5421CollectionsHero: {
		featureFlagName: 'gwp-5421-collections-hero',
		metadata: {
			description: 'Collections hero takeover on homepage',
			expectedReleaseDate: '4/9/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/'],
			},
		},
	},
	gwp8165EnterpriseContactServiceCollection: {
		featureFlagName: 'gwp-8165-enterprise-contact-service-collection',
		metadata: {
			description: 'Feature gate to enable Service Collection option in enterprise contact forms',
			expectedReleaseDate: '10/01/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/enterprise/contact'],
			},
		},
	},
	gwp9286ConfluenceAnchorUpdates: {
		featureFlagName: 'gwp-9286-confluence-anchor-updates',
		metadata: {
			description: 'Confluence Anchor Updates',
			expectedReleaseDate: '12/19/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/confluence'],
			},
		},
	},
	gwp9287JSMAnchorUpdates: {
		featureFlagName: 'gwp-9287-jsm-anchor-updates',
		metadata: {
			description: 'JSM Anchor Updates',
			expectedReleaseDate: '12/15/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/jira/service-management'],
			},
		},
	},
	gwp9473JSWAnchorUpdates: {
		featureFlagName: 'gwp-9473-jsw-anchor-updates',
		metadata: {
			description: 'Jira Anchor Updates',
			expectedReleaseDate: '12/19/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/jira'],
			},
		},
	},
	voltronGupsDataInAnalyticsWrapper: {
		featureFlagName: 'voltron-gups-data-in-analytics-wrapper',
		metadata: {
			description: 'Add gups storage and retrieval of utm data in analytics wrapper',
			expectedReleaseDate: '4/11/2025',
			expectedRuntime: 'indefinite',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	gwp737EnableIntercomChatHome: {
		featureFlagName: 'gwp-737-enable-intercom-chat-home',
		metadata: {
			description: 'Triggers boot intercom on home page',
			expectedReleaseDate: '',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/'],
			},
		},
	},
	gwp737EnableIntercomChatJsw: {
		featureFlagName: 'gwp-737-enable-intercom-chat-jsw',
		metadata: {
			description: 'Triggers boot intercom on Jira Software pages',
			expectedReleaseDate: '',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/jira'],
			},
		},
	},
	wacLiftedBannerSticky: {
		featureFlagName: 'wac-lifted-banner-sticky',
		metadata: {
			description: 'Lifted banner sticky',
			expectedReleaseDate: '',
			expectedRuntime: '',
			context: {
				urls: [
					'/',
					'/software/confluence',
					'/jira',
					'/software/jira/service-management',
					'/software/jira',
				],
			},
		},
	},
	gwp5682RemoveRovoFromPricingForm: {
		featureFlagName: 'gwp-5682-remove-rovo-from-pricing-form',
		metadata: {
			description: 'Remove rovo from pricing form',
			expectedReleaseDate: '4/9/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/enterprise/contact'],
			},
		},
	},
	gwp6474RemoveOpsgenieContactSalesForm: {
		featureFlagName: 'gwp-6474-remove-opsgenie-contact-sales-form',
		metadata: {
			description: 'Remove rovo from contact form',
			expectedReleaseDate: '06/04/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/enterprise/contact'],
			},
		},
	},
	gwp8238BannerAnnouncement: {
		featureFlagName: 'gwp-8238-banner-announcement',
		metadata: {
			description: 'GWP-8238 Banner announcement for homepage and Jira software page',
			expectedReleaseDate: '9/18/2025',
			expectedRuntime: '2 weeks',
			context: {
				urls: ['/', '/software/jira'],
			},
		},
	},
	gwp6473JpdPremiumBanner: {
		featureFlagName: 'gwp-5810-nonprofit-pricing-changes',
		metadata: {
			description: 'JPD Premium Announcement',
			expectedReleaseDate: '6/03/2025',
			expectedRuntime: '2 weeks',
			context: {
				urls: ['/software/jira/product-discovery', '/software/jira/product-discovery/pricing'],
			},
		},
	},
	wacUipButterBarJsmGate: {
		featureFlagName: 'wac-uip-butter-bar-jsm-gate',
		metadata: {
			description: 'Forrester banner',
			expectedReleaseDate: 'unknown',
			expectedRuntime: 'unknown',
			context: {
				urls: ['/software/jira/service-management'],
			},
		},
	},
	gwp6701ForresterBanner: {
		featureFlagName: 'gwp-6701-forrester-banner',
		metadata: {
			description: 'Forrester banner',
			expectedReleaseDate: '6/16/2025',
			expectedRuntime: 'Two weeks',
			context: {
				urls: ['/software/jira/service-management'],
			},
		},
	},
	gwp6524OpsgenieSignupEol: {
		featureFlagName: 'gwp-6524-opsgenie-signup-eol',
		metadata: {
			description: 'Opsgenie EOL',
			expectedReleaseDate: '6/04/2025',
			expectedRuntime: 'Operational Flag',
			context: {
				urls: ['/try/cloud/signup?bundle=jira-service-desk'],
			},
		},
	},
	confluencePricingPageWaeMigration: {
		featureFlagName: 'confluence_pricing_wae_migration_exp_rerun_gate_1',
		metadata: {
			description: 'migration of Confluence pricing page to WAE, rerun',
			expectedReleaseDate: '03/06/2026',
			expectedRuntime: '80 days',
			context: {
				urls: ['/software/confluence/pricing'],
			},
		},
	},
	gwp7856PricingPagesWaeMigrationM3: {
		featureFlagName: 'gwp-7856-pricing-pages-wae-migration-m3-1',
		metadata: {
			description: 'migration of pricing pages to WAE, milestone-3',
			expectedReleaseDate: 'ongoing',
			expectedRuntime: '',
			context: {
				urls: [
					'/collections/teamwork/pricing',
					'/collections/strategy/pricing',
					'/software/guard/pricing',
					'/software/compass/pricing',
					'/software/loom/pricing',
					// ...add more pricing urls here
				],
			},
		},
	},
	routingTable: {
		featureFlagName: 'wac-routing-table-gate',
		metadata: {
			description: 'Uses wac-routing-table to identify Uniform-supported pages in WACs',
			expectedReleaseDate: '8/07/2025',
			expectedRuntime: '',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	useWacman: {
		featureFlagName: 'wac_composition_cutover',
		metadata: {
			description:
				'Uses WAC Management Service for compositions and explicit regeneration; WACMAN owns automatic regeneration',
			expectedReleaseDate: 'TBD',
			expectedRuntime: 'TBD',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	gwp7617JiraShortTermAiInfusionGate: {
		featureFlagName: 'gwp-7617-jira-short-term-ai-infusion-gate',
		metadata: {
			description: 'Short term updates to Jira page',
			expectedReleaseDate: '8/21/2025',
			expectedRuntime: '',
			context: {
				urls: ['/software/jira'],
			},
		},
	},
	gwp7999JiraFeatures: {
		featureFlagName: 'gwp-7999-jira-features',
		metadata: {
			description: 'Feature gate to conditionally hide tabs section on Jira features page',
			expectedReleaseDate: 'TBD',
			expectedRuntime: 'TBD',
			context: {
				urls: ['/software/jira/features'],
			},
		},
	},
	gwp8240ButterbarGuard: {
		featureFlagName: 'gwp-8240-butterbar-guard',
		metadata: {
			description: 'Guard workshop banner',
			expectedReleaseDate: '11/11/2025',
			expectedRuntime: '',
			context: {
				urls: ['/software/guard/pricing'],
			},
		},
	},
	bxpActivationCmtCcpIntegration: {
		featureFlagName: 'bxp-activation-cmt-ccp-integration',
		metadata: {
			description: 'Enable CMT signups through CCP by sending migrationId in /activate-product',
			expectedReleaseDate: '05/06/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/try/cloud/signup'],
			},
		},
	},
	accountCreationTermsAndConditions: {
		featureFlagName: 'account-creation-terms-and-conditions',
		metadata: {
			description: 'show terms and conditions by default in AccountCreation',
			expectedReleaseDate: '2026-06-08',
			expectedRuntime: '',
			context: {
				urls: [
					'/software/confluence',
					'/software/jira',
					'/software/jira/service-management',
					'/try/cloud/signup',
				],
			},
		},
	},
	bxpActivationBitbucketCmtCcpIntegration: {
		featureFlagName: 'bxp-activation-bitbucket-cmt-ccp-integration',
		metadata: {
			description:
				'Force edition=premium for Bitbucket CMT signups so /activate-product receives the correct edition',
			expectedReleaseDate: '05/14/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/try/cloud/signup'],
			},
		},
	},
	wacProductCollectionSignup: {
		featureFlagName: 'wac_product_collection_signup',
		metadata: {
			description:
				'Enable Product Collection self-serve signup (bundle=product-collection) on the WAC signup and confirmation pages. Gated by this flag only (STARB-4842)',
			expectedReleaseDate: '03/31/2027',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/try/cloud/signup', '/ondemand/signup/confirmation'],
			},
		},
	},
	gwp7546ConfluencePricingCtaCtaUrlSource: {
		featureFlagName: 'gwp-7546-confluence-pricing-cta-ctaurlsource',
		metadata: {
			description: 'Change the Confluence pricing ctaUrlSource to productPlans',
			expectedReleaseDate: '8/22/2025',
			expectedRuntime: '',
			context: {
				urls: ['/software/confluence/pricing'],
			},
		},
	},
	gwp7456JpdStateOfProductBanner: {
		featureFlagName: 'gwp-7456-jpd-state-of-product-banner',
		metadata: {
			description: 'Enable JPD State of Product Banner',
			expectedReleaseDate: '9/3/2025',
			expectedRuntime: '7 days',
			context: {
				urls: ['/software/jira/product-discovery'],
			},
		},
	},
	gwp8038JpdBannerWebinar: {
		featureFlagName: 'gwp-8038-jpd-banner-webinar',
		metadata: {
			description: 'Enable JPD webinar banner to replace State of Product banner',
			expectedReleaseDate: '9/11/2025',
			expectedRuntime: '2 weeks',
			context: {
				urls: ['/software/jira/product-discovery'],
			},
		},
	},
	EnableJPDXflowLofiSignup: {
		featureFlagName: 'gwp-7564-integrate-jpd-xflow-lofi-signup',
		metadata: {
			description: 'Enable JPD Xflow Lofi Signup',
			expectedReleaseDate: '8/28/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/'],
			},
		},
	},
	killRovoDevSignup: {
		featureFlagName: 'kill-rovo-dev-signup',
		metadata: {
			description:
				'Kill-switch for Rovo Dev self-service sign-up. When enabled, the Rovo Dev signup page renders a "no longer available" message with a contact sales link instead of the signup form, for both logged-in and logged-out users.',
			expectedReleaseDate: '09/17/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/try/cloud/signup'],
			},
		},
	},
	enableRovoDevBetaSignup: {
		featureFlagName: 'rovo_dev_beta_signup_backup',
		metadata: {
			description: 'Enable Rovo Dev Beta Signup',
			expectedReleaseDate: '09/19/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/'],
			},
		},
	},
	dxpMigrationJiraProductTourGate: {
		featureFlagName: 'dxp-migration-jira-product-tour-gate',
		metadata: {
			description: 'Enable Jira Product Tour Migration for Team 25 EU',
			expectedReleaseDate: '10/07/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/jira', '/jira'],
			},
		},
	},
	gwp8037ServiceCollectionPricingPage: {
		featureFlagName: 'gwp-8037-service-collection-pricing-page',
		metadata: {
			description: 'Feature gate for Service Collection Pricing page',
			expectedReleaseDate: '9/30/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/collections/service/pricing'],
			},
		},
	},

	gwp8011RovoProductTour: {
		featureFlagName: 'gwp-8011-rovo-product-tour',
		metadata: {
			description: 'Feature gate for Rovo Product Tour',
			expectedReleaseDate: '10/3/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/rovo'],
			},
		},
	},
	gwp8036RovoDevPricingPage: {
		featureFlagName: 'gwp-8036-rovo-dev-pricing-page',
		metadata: {
			description: 'Feature gate for Rovo Dev pricing page',
			expectedReleaseDate: '9/30/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/rovo-dev/pricing'],
			},
		},
	},
	gwp7923NewJsmRouteDeIndex: {
		featureFlagName: 'gwp-7923-new-jsm-route-de-index',
		metadata: {
			description: 'Feature gate for new JSM route, and de-indexing old route',
			expectedReleaseDate: '9/30/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: [
					'/software/jira/service-management/pricing',
					'/software/jira/service-management/product-pricing',
				],
			},
		},
	},
	dxpMigrationConfluenceProductTourGate: {
		featureFlagName: 'dxp-migration-confluence-product-tour-gate',
		metadata: {
			description: 'Enable Confluence Product Tour Migration for Team 25 EU',
			expectedReleaseDate: '10/07/2025',
			expectedRuntime: 'Forever (gate to be used for launch, will be cleaned up after)',
			context: {
				urls: ['software/confluence'],
			},
		},
	},
	gwpRovoProductTourStudioTab: {
		featureFlagName: 'gwp-rovo-product-tour-studio-tab',
		metadata: {
			description: 'Update copy and CTA for Rovo Product Tour Studio Tab on Oct 8',
			expectedReleaseDate: '10/08/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['software/rovo'],
			},
		},
	},
	gwp7823AnimationOverlayOption: {
		featureFlagName: 'gwp-7823-animation-overlay-option',
		metadata: {
			description: 'Feature gate for animation overlay option',
			expectedReleaseDate: '10/03/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/rovo'],
			},
		},
	},
	gwp8279CollectionHeroIntl: {
		featureFlagName: 'gwp-8279-collection-hero-intl',
		metadata: {
			description: 'Enables hardcoded translation strings in the collection-pricing-hero component',
			expectedReleaseDate: '10/06/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: [
					'/collection/service/pricing',
					'/collection/teamwork/pricing',
					'/collection/strategy/pricing',
				],
			},
		},
	},
	gwp8510AustinGrandPrixBanner: {
		featureFlagName: 'gwp-5810-austin-grand-prix',
		metadata: {
			description: 'Austin Grand Prix banner on homepage',
			expectedReleaseDate: '10/14/2025',
			expectedRuntime: '2 weeks',
			context: {
				urls: ['/'],
			},
		},
	},
	gwp8577ServiceCollectionBanners: {
		featureFlagName: 'gwp-8577-service-collection-banners',
		metadata: {
			description: 'Feature gate for service collection banners',
			expectedReleaseDate: '11/03/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/jira/service-management'],
			},
		},
	},
	gwp9038JdpAIWebinarBanner: {
		featureFlagName: 'gwp-9038-jdp-ai-webinar-banner',
		metadata: {
			description: 'Feature gate for GWP-9038',
			expectedReleaseDate: '11/17/2025',
			expectedRuntime: '2 weeks',
			context: {
				urls: ['/software/jira/product-discovery'],
			},
		},
	},
	gwp9000NewRovoVideoHero: {
		featureFlagName: 'gwp-9000-new-rovo-video-hero',
		metadata: {
			description: 'showing rovo video',
			expectedReleaseDate: '2025-11-19',
			expectedRuntime: '1 month',
			context: {
				urls: ['/software/rovo'],
			},
		},
	},
	gwp9226Team26Banner: {
		featureFlagName: 'gwp-9226-team-26-banner',
		metadata: {
			description: 'Team 26 Banners on WAC Homepage',
			expectedReleaseDate: '2026-01-05',
			expectedRuntime: '1 month',
			context: {
				urls: ['/'],
			},
		},
	},
	gwp9034WacPricingCcpStaging: {
		featureFlagName: 'gwp-9034-wac-pricing-ccp-staging',
		metadata: {
			description:
				'When enabled, WAC fetches its pricing data from the ccp_staging space in Contentful > Product Catalog',
			expectedReleaseDate: '11/20/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/*/pricing', '/collections/*/pricing'],
			},
		},
	},
	gwp9214HomepageScreenshots: {
		featureFlagName: 'gwp-9214-homepage-screenshots',
		metadata: {
			description: 'Updated screenshots for homepage scroll pinned sections',
			expectedReleaseDate: '12/03/2025',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/'],
			},
		},
	},
	enableCsmAjLogo: {
		featureFlagName: 'enable-csm-aj-logo',
		metadata: {
			description: 'Enable Customer Service Management logo on CSM variant in JSM Anchor Journey',
			expectedReleaseDate: '12/08/2025',
			expectedRuntime: 'indefinite',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	jiraPricingWaeMigrationExperimentRerunGate: {
		featureFlagName: 'jira_pricing_wae_migration_exper_rerun_exp_1_gate',
		metadata: {
			description: 'Rerun of migration of Jira pricing page to WAE',
			expectedReleaseDate: '03/06/2026',
			expectedRuntime: '43 days',
			context: {
				urls: ['/software/jira/pricing'],
			},
		},
	},
	waePricingDisableComparePlansEnhancer: {
		featureFlagName: 'wae-pricing-disable-compare-plans-enhancer',
		metadata: {
			description:
				'Toggle ON to DISABLE server-side fetching of product catalog data for WAE pricing pages',
			expectedReleaseDate: '03/25/2026',
			expectedRuntime: 'indefinte',
			context: {
				urls: ['/software/*/pricing'],
			},
		},
	},
	waePricingStripExcessData: {
		featureFlagName: 'wae-pricing-strip-excess-data',
		metadata: {
			description:
				'Enable this for WAE enhancers to strip excess data from pricing page SSR payloads',
			expectedReleaseDate: '04/05/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/*/pricing'],
			},
		},
	},
	waePricingGql: {
		featureFlagName: 'gwp-11369-wae-pricing-gql',
		metadata: {
			description: 'Enables GQL fetching on WAE pricing',
			expectedReleaseDate: '05/08/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/*/pricing', '/collections/*/pricing'],
			},
		},
	},
	wacIcLogin: {
		featureFlagName: 'wac-ic-login',
		metadata: {
			description: "Feature gate to add application query parameter 'wac--ic' to enable IC logins",
			expectedReleaseDate: '01/12/2026',
			expectedRuntime: '04/01/2026',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	includeEntitlementIdCheckInCohortsGate: {
		featureFlagName: 'astro_786_entitlement_id_check_in_cohort',
		metadata: {
			description: 'Gate to introduce the check for entitlemnt Id and billing source system',
			expectedReleaseDate: '01/08/2026',
			expectedRuntime: '14 days',
			context: {
				urls: ['/try/cloud/signup'],
			},
		},
	},
	gwp9763BackupRestoreContactForm: {
		featureFlagName: 'gwp-9763-backup-restore-contact-form',
		metadata: {
			description: 'Feature gate to enable Backup and Restore product option',
			expectedReleaseDate: '01/22/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/enterprise/contact'],
			},
		},
	},
	gwp9608AdditionalSandboxContactForm: {
		featureFlagName: 'gwp-9608-enterprise-contact-additional-sandbox',
		metadata: {
			description:
				'Feature gate to enable Additional Sandbox product options in enterprise contact forms',
			expectedReleaseDate: '01/25/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/enterprise/contact'],
			},
		},
	},
	gwp11663AtlassianIsolatedCloudContactForm: {
		featureFlagName: 'gwp-11663-atlassian-isolated-cloud-contact-form',
		metadata: {
			description: 'Feature gate to enable Atlassian Isolated Cloud in enterprise contact forms',
			expectedReleaseDate: '06/01/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/enterprise/contact'],
			},
		},
	},
	gwp9365TeamOnTourSydneyBanner: {
		featureFlagName: 'gwp-9365-team-on-tour-sydney-homepage-banner-au-nz',
		metadata: {
			description: 'Team on Tour Sydney Banner on WAC Homepage',
			expectedReleaseDate: '2026-02-04',
			expectedRuntime: '33 days',
			context: {
				urls: ['/'],
			},
		},
	},
	gwp9191Team26HeroHomepageTakeover: {
		featureFlagName: 'gwp-9191-team-26-hero-homepage-takeover',
		metadata: {
			description: 'Team 26 hero takeover',
			expectedReleaseDate: '02/02/2026',
			expectedRuntime: '04/18/2026',
			context: {
				urls: ['/'],
			},
		},
	},
	gwp10221RovoProductTourFixScrollAnimation: {
		featureFlagName: 'gwp-10221-rovo-product-tour-fix-scroll-animation',
		metadata: {
			description:
				'Updated headline, reordered rovo section on homepage - converted from experiment to feature gate',
			expectedReleaseDate: '02/17/2025',
			expectedRuntime: '3 days',
			context: {
				urls: ['/software/rovo'],
			},
		},
	},
	gwp10027NonprofitPricingPage: {
		featureFlagName: 'gwp-10027-nonprofit-pricing-page',
		metadata: {
			description: 'Nonprofit pricing page changes FY26Q3',
			expectedReleaseDate: '02/25/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/teams/nonprofits/discount-pricing'],
			},
		},
	},
	gwp10416DisableNonOperationalAnalyticsGateUip: {
		featureFlagName: 'gwp-10416-disable-non-operational-analytics-uip',
		metadata: {
			description:
				'Feature gate to only enable operational analytics events in atl-analytics wrapper when users are opted out of performance cookies',
			expectedReleaseDate: '03/02/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/'],
			},
		},
	},
	gwp11118UsageBasedPricingCalculator: {
		featureFlagName: 'gwp-11118-usage-based-pricing-calculator',
		metadata: {
			description: 'Feature gate to enable the Usage-Based Pricing Calculator',
			expectedReleaseDate: '05/05/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/resources/usage/calculator'],
			},
		},
	},
	voltronMultiTouchAnalytics: {
		featureFlagName: 'voltron-multi-touch-analytics-gate',
		metadata: {
			description: 'Feature gate to enable voltron multi-touch tracking',
			expectedReleaseDate: '04/15/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/'],
			},
		},
	},
	wacRefreshTeam26Gate: {
		featureFlagName: 'wac_refresh_q4fy26_gate',
		metadata: {
			description: 'Feature Gate to enable WAC Refresh',
			expectedReleaseDate: '05/05/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: [
					'/',
					'/software/jira',
					'/software/confluence',
					'/software/rovo',
					'/collections/teamwork',
				],
			},
		},
	},
	gwp10907JpdEnterpriseSku: {
		featureFlagName: 'gwp-10907-jpd-enterprise-sku',
		metadata: {
			description:
				'Feature gate to roll out the new JPD Enterprise SKU column on the Jira Product Discovery pricing page',
			expectedReleaseDate: '05/06/2026',
			expectedRuntime: '12 weeks',
			context: {
				urls: ['/software/jira/product-discovery/pricing'],
			},
		},
	},
	gwpGlobalNavHoverVClick: {
		featureFlagName: 'gwp-global-nav-hover-v-click',
		metadata: {
			description: 'Toggle nav expand interaction model (click vs hover)',
			expectedReleaseDate: '05/06/2026',
			expectedRuntime: 'indefinite',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	team26Keynote: {
		featureFlagName: 'wac_team26_keynote',
		metadata: {
			description: 'Feature Gate to enable Team 26 changes timed with Keynote',
			expectedReleaseDate: '05/06/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/', '/software/confluence', '/software/rovo', '/enterprise/contact'],
			},
		},
	},
	gwp1072SunsetCompass: {
		featureFlagName: 'gwp-10723-compass-gate',
		metadata: {
			description: 'Feature gate to sunset Compass',
			expectedReleaseDate: '05/13/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/'],
			},
		},
	},
	gwp9582ProductCollection: {
		featureFlagName: 'gwp-9582-product-collection',
		metadata: {
			description: 'Show product collections',
			expectedReleaseDate: '05/13/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/'],
			},
		},
	},
	statuspageOfferingDisplay: {
		featureFlagName: 'bauscrum-5310-statuspage-offering-display',
		metadata: {
			description:
				'BAUSCRUM-5310: Show Statuspage branding and the commercial offering name on eligible post-order cards. When off, retain the original icon and edition label without requesting offering names.',
			expectedReleaseDate: 'TBD',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/buy/cloud/site-setup'],
			},
		},
	},
	cmkRedirectExistingEntitlement: {
		featureFlagName: 'cmk_redirect_existing_entitlement',
		metadata: {
			description:
				'Redirect users with existing CMK entitlement to CMK support page during post-order provisioning',
			expectedReleaseDate: '2026-06-15',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/buy/cloud/post-order-provisioning', '/buy/cloud/org-setup'],
			},
		},
	},
	jiraWacActivationChecklistGate: {
		featureFlagName: 'wac-jira-activation-checklist-gate',
		metadata: {
			description:
				"Ops kill switch + ring-0 rollout lever in front of the WAC product activation checklist placement on /software/jira. Mounted directly below the user's most-recently-accessed Jira site card.",
			expectedReleaseDate: '2026-06-01',
			expectedRuntime: 'indefinite (kill switch)',
			context: {
				urls: ['/software/jira'],
			},
		},
	},
	wacDwellTimeTracking: {
		featureFlagName: 'wac_dwell-time_tracking',
		metadata: {
			description:
				'Master switch for the dwell-time tracking system (DwellTimeContextProvider). When off, no tracker mounts and no analytics fire regardless of consumer opt-in.',
			expectedReleaseDate: '2026-06-26',
			expectedRuntime: 'indefinite',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	team26EuAnnouncementBanner: {
		featureFlagName: 'team26-eu-announcement-banner',
		metadata: {
			description: 'Feature gate for banner announcing TEAM 26 EU event',
			expectedReleaseDate: '2026-06-16',
			expectedRuntime: '6 weeks',
			context: {
				urls: ['/'],
			},
		},
	},
	jpdWacRedirectTemplateAfterLogin: {
		featureFlagName: 'jpd_wac_redirect_template_after_login',
		metadata: {
			description:
				'When enabled, appends a tryTemplate query param to the signup continue URL and auto-opens the site selector modal when the user returns to the WAC templates page after signup, eliminating the need to click "Use Template" a second time.',
			expectedReleaseDate: '2026-10-30',
			expectedRuntime: 'temporary',
			context: {
				urls: ['/software/jira/templates/*'],
			},
		},
	},
	gwp12021AddDX: {
		featureFlagName: 'gwp-12021-dx-enterprise-form-gate',
		metadata: {
			description: 'Feature gate to rollout the addition of DX to the enterprise contact form',
			expectedReleaseDate: '08/17/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/enterprise/contact'],
			},
		},
	},
	gwpEnterpriseRolloutGateTwc: {
		featureFlagName: 'gwp-enterprise-rollout-gate-twc',
		metadata: {
			description: 'Feature gate for enterprise rollout of Team Workflow Collaboration (TWC)',
			expectedReleaseDate: 'Indefinite',
			expectedRuntime: 'Indefinite',
			context: {
				urls: ['/enterprise/contact'],
			},
		},
	},
	twcg1930TwcWacHomepage: {
		featureFlagName: 'twcg-1930-twc-wac-homepage-gate',
		metadata: {
			description:
				'Enable the TWC xflow modal from the WAC Teamwork Collection signup flow when explicitly requested by the originating WAC homepage experience.',
			expectedReleaseDate: '09/01/2026',
			expectedRuntime: '6 weeks',
			context: {
				urls: ['/try/cloud/signup'],
			},
		},
	},
	gwpEnterpriseRolloutGateStrategyCollection: {
		featureFlagName: 'gwp-enterprise-rollout-gate-strategy-collection',
		metadata: {
			description: 'Feature gate for enterprise rollout of strategy collection',
			expectedReleaseDate: 'Indefinite',
			expectedRuntime: 'Indefinite',
			context: {
				urls: ['/enterprise/contact'],
			},
		},
	},
	gwp12437MatchPricingPlansByOfferingKey: {
		featureFlagName: 'gwp-12437-match-pricing-plans-by-offering-key',
		metadata: {
			description:
				'Match CCP pricing plans to their offering by offeringKey instead of offeringName, so name collisions across products no longer pull in the wrong plans',
			expectedReleaseDate: '07/14/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: [
					'/resources/usage/calculator',
					'/software/jira/pricing',
					'/software/confluence/pricing',
				],
			},
		},
	},
	gwp12227EnterpriseUsagePacks: {
		featureFlagName: 'gwp-12227-enterprise-usage-packs',
		metadata: {
			description:
				'Feature gate to enable the Usage Packs tab, self-serve help panel, and estimated usage field in the enterprise contact forms',
			expectedReleaseDate: 'Indefinite',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/enterprise/contact'],
			},
		},
	},
	ubpPackOrgRedirectionFix: {
		featureFlagName: 'ubp-pack-org-redirection-fix',
		metadata: {
			description:
				'Redirect UBP pack-only post-order provisioning to the Admin Hub billing entitlement page instead of a bogus product-instance URL. Kill switch: when off, transactionAccount is not forwarded to the confirmation page, so the redirect falls back to prior behavior. BAC-12248.',
			expectedReleaseDate: '08/05/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/buy/cloud/org-setup'],
			},
		},
	},
	d1d6JiraPTLocaleGrsFetcher: {
		featureFlagName: 'd1d6-jira-pt-locale-grs-fetcher',
		metadata: {
			description:
				'Gate the WAE contextual-bandits GRS request for Jira PT Locale. When on, the fetcher resolves the Jira PT Locale context from the container useCaseId',
			expectedReleaseDate: '08/21/2026',
			expectedRuntime: '1 month',
			context: {
				urls: ['/software/jira'],
			},
		},
	},
	cfind6214WacLandingForAiNativeTeamsPtGate: {
		featureFlagName: 'cfind-6214-wac-landing-for-ai-native-teams-pt-gate',
		metadata: {
			description: 'Feature gate for the WAC landing page for AI-native teams (cfind-6214)',
			expectedReleaseDate: '08/18/2026',
			expectedRuntime: '1 month',
			context: {
				urls: ['/software/jira'],
			},
		},
	},
	rovoDevEolProductNav: {
		featureFlagName: 'rovo_dev_eol_product_nav',
		metadata: {
			description:
				'Removes the pricing link from the nav, & updates CTA. https://hello.jira.atlassian.cloud/browse/WEBTEAM-22469',
			expectedReleaseDate: '10/01/2026',
			expectedRuntime: 'indefinite',
			context: {
				urls: ['/software/rovodev, /software/rovodev/*'],
			},
		},
	},
	team26EuHomepageVideoGate: {
		featureFlagName: 'team_26_eu_homepage_video_gate',
		metadata: {
			description: 'Team 26 (Growth - TOFU - Spark) EU gate controlling the homepage video.',
			expectedReleaseDate: 'TBD',
			expectedRuntime: 'Indefinite',
			context: {
				urls: ['/'],
			},
		},
	},
	personalizationNoContentSwap: {
		featureFlagName: 'wac_personalization_no_content_swap',
		metadata: {
			description:
				'Personalization and contextual bandits containers settle on the default slot when no variant can match, and otherwise render the loading slot from SSR, so visitors never see the default and then a different variant.',
			expectedReleaseDate: 'TBD',
			expectedRuntime: '4 weeks',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	wacSeoDetailsSocialFallback: {
		featureFlagName: 'wac_seo_details_social_fallback',
		metadata: {
			description:
				'GWP-13707: When ON, Open Graph / Twitter meta tags ignore unusable Uniform page values (empty, non-string, unresolved Contentful SEO Details connections, or non-http(s) image URLs) and fall back to page title, description, and hero or default image. Turn ON before connecting Page OG/Twitter parameters to Contentful SEO Details.',
			expectedReleaseDate: '11/30/2026',
			expectedRuntime: '1 month',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
	localizedJsonLd: {
		featureFlagName: 'localized-json-ld',
		metadata: {
			description:
				'D1D6-441: Enables code-owned (react-intl / Traduki) translations in server-rendered JSON-LD. When off or unavailable, code-owned JSON-LD text stays in English. Uniform-sourced values and jsonLdOverride are not affected.',
			expectedReleaseDate: 'TBD',
			expectedRuntime: 'Indefinite',
			context: {
				// eslint-disable-next-line local/warn-wildcard-usage-eslint
				urls: ['*'],
			},
		},
	},
} satisfies FeatureFlagManifest;
